import wlmTailCargoDialog from './main';

export default {
  install(Vue) {
    Vue.component(wlmTailCargoDialog.name, wlmTailCargoDialog);
  },
};

